import React, { useState, useEffect } from 'react';
import { useOrion } from '../context/OrionContext';
import { ehDesktop } from '../services/plataforma';
import LogoOrion from './LogoOrion';

// ─────────────────────────────────────────────────────────────────────────────
// Tela de entrada.
//
// Estrutura e classes portadas do LoginScreen do Nexus (role-screen /
// role-container / role-logo / login-form). O estilo vem de
// styles/OrionLogin.css, que é o bloco correspondente do App.css de lá.
//
// A autenticação em si é do Orion: um webhook do n8n contra o cadastro da
// Space (ver services/authApi.js). Quando "lembrar" está marcado, o próximo
// início entra sozinho — quem faz isso é o OrionContext, então nesse caso esta
// tela nem chega a aparecer.
// ─────────────────────────────────────────────────────────────────────────────

export default function TelaLogin() {
  const { entrar, erroLogin, autenticando, credenciais, versao } = useOrion();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [lembrar, setLembrar] = useState(false);

  // Pré-preenche com o que ficou guardado (útil no "trocar operador", onde a
  // sessão foi encerrada mas as credenciais continuam salvas).
  useEffect(() => {
    setEmail(credenciais.email || '');
    setLembrar(!!credenciais.lembrar);
    if (credenciais.lembrar && credenciais.senha) setSenha(credenciais.senha);
  }, [credenciais]);

  const enviar = (e) => {
    e.preventDefault();
    if (autenticando) return;
    entrar(email, senha, lembrar);
  };

  return (
    <div className="orion-entrada">
      <div className="role-screen">
        <div className="role-container">
          <div className="role-logo">
            <span className="logo-icon"><LogoOrion size={30} /></span>
            <span className="logo-text">Orion</span>
          </div>
          <p className="role-subtitle">Entre com sua conta Space</p>

          <form className="login-form" onSubmit={enviar}>
            <label className="login-label">
              Usuário ou e-mail
              <input
                type="text"
                className="login-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoFocus
                autoComplete="username"
                placeholder="seu.usuario"
              />
            </label>

            <label className="login-label">
              Senha
              <input
                type="password"
                className="login-input"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                autoComplete="current-password"
                placeholder="••••••••"
              />
            </label>

            <label className="login-remember">
              <input
                type="checkbox"
                checked={lembrar}
                onChange={(e) => setLembrar(e.target.checked)}
              />
              Lembrar credenciais
            </label>

            {erroLogin && <div className="login-error">{erroLogin}</div>}

            <button type="submit" className="login-btn" disabled={autenticando}>
              {autenticando ? 'Entrando…' : 'Entrar'}
            </button>
          </form>

          <div className="login-rodape">
            {versao ? `v${versao}` : ''}{versao ? ' · ' : ''}{ehDesktop ? 'Desktop' : 'Web'}
          </div>
        </div>
      </div>
    </div>
  );
}
